import React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import { ArrowDownwardIcon, MoneyIcon } from "./AppIcons";
import { Litros, Reais } from "./numberUtils";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56,
  },
  differenceIcon: {
    color: colors.red[900],
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1),
  },
}));

export interface IndicadorProps {
  titulo: string;
  valor: number;
  comparativo?: IndicadorProps;
}

export const Indicador = ({ valor, titulo, comparativo }: IndicadorProps) => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Grid container justifyContent="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="caption">
              {titulo}
            </Typography>
            <Typography color="textPrimary" variant="h6">
              {valor}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <MoneyIcon />
            </Avatar>
          </Grid>
        </Grid>
        {comparativo && (
          <Box mt={2} display="flex" alignItems="center">
            <ArrowDownwardIcon className={classes.differenceIcon} />
            <Typography className={classes.differenceValue} variant="body2">
              {comparativo.valor}
            </Typography>
            <Typography color="textSecondary" variant="caption">
              {comparativo.titulo}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export const IndicadorFlat = ({
  valor,
  titulo,
  r$,
  lt,
  showDecimals,
  children,
}: any) => {
  return (
    <Grid container justifyContent="space-between" spacing={3}>
      <Grid item>
        <Typography color="textSecondary" gutterBottom variant="caption">
          {titulo}
        </Typography>
        <Typography color="textPrimary" variant="h6">
          {lt && <Litros valor={valor} showDecimals={showDecimals} />}
          {r$ && <Reais valor={valor} showDecimals={showDecimals} />}
          {!lt && !r$ && valor}
        </Typography>
        {children}
      </Grid>
    </Grid>
  );
};
